import { CMECONSTANT } from './constants/cme_c';

import _u from './util';
import _v from './vars';

import _ from 'lodash';

const _f = {
	
	getCmeCreditTypeValue: function(cmeCreditTypeValue) {
		try {
			if (typeof cmeCreditTypeValue == 'undefined' || cmeCreditTypeValue == null || cmeCreditTypeValue == "" || _.isEmpty(cmeCreditTypeValue)) {
				return '';
			}

			let creditValue = '';
			let creditText = '';
			const parsedJson = cmeCreditTypeValue;
			let creditLabel = 'credit';

			const cmeVal = parsedJson.filter(function (x) {
				return x.creditTypeName === "CME"
			});

			if (typeof cmeVal != 'undefined' && cmeVal.length > 0) {
				creditValue = cmeVal[0].cmeCredits;
			} else {
				for (const key in parsedJson) {
					if (parsedJson[key].creditTypeName != "LOC") {
						creditValue = parsedJson[key].cmeCredits;
					}
				}
			}

			for (const key in parsedJson) {
				if (parsedJson[key].creditTypeName != "LOC") {
					const value = _.filter(CMECONSTANT, {
						creditTypeId: parsedJson[key].creditTypeID.toString(),
					});

					if (creditText.indexOf(value[0].computedName) < 0) {
						creditText = creditText + value[0].computedName + ' / ';
					}
				}
			}

			String(creditValue).match(/^1(\.00?)?$/) == null ? creditLabel = 'credits' : creditText == "" ? creditLabel = "" : creditLabel = creditLabel;

			if (creditText == "") {
				return "";
			} else {
				return {
					credits: creditValue + ' ' + creditText.slice(0, -2) + ' ' + creditLabel,
					creditType: creditText.slice(0, -2),
					creditvalue: creditValue
				};
			}
		} catch (e) {
			console.log("error" + e);
		}
	},	
	
	closeShare: function () {	
		document.querySelectorAll('.pers-share.active').forEach(function (element) {
			element.classList.remove('active');
			element.classList.remove('shared');
		});
		if (_u.qS('.cme-share-layer') != null) {
			_u.qS('.cme-share-layer').classList.remove('active');
		}
	}
	
};

export default _f;


